import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/HSPortaliBlock.module.scss'

import { Container, Image, Modal } from 'react-bootstrap' // Добавлен Modal

import WhiteBlockTitle from './WhiteBlockTitle'
import GreenButton from './GreenButton'
import StormcloudButton from './StormcloudButton'
import WhiteButton from './WhiteButton'
import FeedbackForm from './FeedbackForm'
import ClientOnlyFsLightbox from './ClientOnlyFsLightbox'

class HSPortaliBlock extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      show_feedback: false,
      form_title: ``,
      lightboxController: {
        toggler: false,
        slide: 1
      },
      // Добавлено состояние для второго лайтбокса со схемами
      lightboxController2: {
        toggler: false,
        slide: 1
      },
      // Добавлено состояние для модального окна видео
      show_video_modal: false,
      current_video_url: '' // URL текущего видео
    }
  }

  showFeedback = ( form_title ) => {
    this.setState({ show_feedback: true, form_title: form_title });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  openLightbox = (index) => {
    this.setState({
      lightboxController: {
        toggler: !this.state.lightboxController.toggler,
        slide: index + 1
      }
    })
  }

  // Добавлена функция для открытия лайтбокса со схемами
  openLightbox2 = (index) => {
    this.setState({
      lightboxController2: {
        toggler: !this.state.lightboxController2.toggler,
        slide: index + 1
      }
    })
  }

  // Функции для работы с видео модальным окном
  openVideoModal = (videoUrl) => {
    this.setState({ 
      show_video_modal: true,
      current_video_url: videoUrl
    });
  }

  closeVideoModal = () => {
    this.setState({ 
      show_video_modal: false,
      current_video_url: ''
    });
  }

  // Функция для извлечения ID видео из URL (аналогично MainFirst)
  extractVideoId(url) {
    if (!url) return null;
    
    // Проверяем Rutube
    const rutubeRegExp1 = /rutube\.ru\/video\/([a-zA-Z0-9]+)/;
    const rutubeRegExp2 = /rutube\.ru\/play\/embed\/([a-zA-Z0-9]+)/;
    
    const rutubeMatch1 = url.match(rutubeRegExp1);
    const rutubeMatch2 = url.match(rutubeRegExp2);
    
    if (rutubeMatch1 && rutubeMatch1[1]) return { type: 'rutube', id: rutubeMatch1[1] };
    if (rutubeMatch2 && rutubeMatch2[1]) return { type: 'rutube', id: rutubeMatch2[1] };
    
    // Проверяем YouTube (обычные видео)
    const youtubeRegExp1 = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
    const youtubeRegExp2 = /youtube\.com\/embed\/([^"&?\/\s]{11})/;
    
    const youtubeMatch1 = url.match(youtubeRegExp1);
    const youtubeMatch2 = url.match(youtubeRegExp2);
    
    if (youtubeMatch1 && youtubeMatch1[1]) return { type: 'youtube', id: youtubeMatch1[1] };
    if (youtubeMatch2 && youtubeMatch2[1]) return { type: 'youtube', id: youtubeMatch2[1] };
    
    // Проверяем YouTube Shorts
    const shortsRegExp = /youtube\.com\/shorts\/([^"&?\/\s]{11})/;
    const shortsMatch = url.match(shortsRegExp);
    
    if (shortsMatch && shortsMatch[1]) return { type: 'youtube', id: shortsMatch[1] };
    
    return null;
  }

  getEmbedUrl(videoInfo) {
    if (!videoInfo) return null;
    
    if (videoInfo.type === 'rutube') {
      return `https://rutube.ru/play/embed/${videoInfo.id}/`;
    } else if (videoInfo.type === 'youtube') {
      return `https://www.youtube.com/embed/${videoInfo.id}`;
    }
    
    return null;
  }

  formatSlideNumber = (index) => {
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {
    const { data, assets_path } = this.props,
    { form_title, show_feedback, lightboxController, lightboxController2, show_video_modal, current_video_url } = this.state

    const imageSources = data?.list.map(item => item.image) || []
    // Создаем массив источников для схем (только те элементы, у которых есть schema)
    const schemaSources = data?.list
      .filter(item => item.schema) // Фильтруем только те, у которых есть схема
      .map(item => item.schema) || []

    // Получаем информацию о текущем видео для модального окна
    const videoInfo = current_video_url ? this.extractVideoId(current_video_url) : null;
    const embedUrl = videoInfo ? this.getEmbedUrl(videoInfo) : '';

    return (
      <section className={`${styles.section}`}>
        <Container>
          <WhiteBlockTitle
            title={data?.title || ``}
          />
          
          {/* Лайтбокс для основных изображений */}
          <ClientOnlyFsLightbox
            toggler={lightboxController.toggler}
            sources={imageSources}
            slide={lightboxController.slide}
          />

          {/* Лайтбокс для схем открывания */}
          <ClientOnlyFsLightbox
            toggler={lightboxController2.toggler}
            sources={schemaSources}
            slide={lightboxController2.slide}
          />

          {data?.list.map( ( elm, k ) => (
            <div className={styles.elm} key={k}>
              <div 
                className={styles.elm_image}
                onClick={() => this.openLightbox(k)}
                style={{cursor: 'pointer'}}
              >
                <Image src={elm?.image} width={262} height={235} alt={elm?.title} />
                <div className={styles.elm_image_k}>{this.formatSlideNumber(k)}</div>
              </div>
              <div className={styles.elm_col2}>
                <h3 className={styles.elm_title} dangerouslySetInnerHTML={{__html: elm?.title}} />
                <div className={styles.elm_subtitle} dangerouslySetInnerHTML={{__html: elm?.subtitle}} />
                <div className={styles.elm_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
              </div>
              <div className={styles.elm_col3}>
                <div>
                  <div className={styles.elm_col3_icons}>
                    <div className={styles.elm_col3_icons_elm}>
                      <Image src={`/${assets_path}/images/maximize-1.svg`} width={20} height={20} alt={`Высота`} />
                      <div>
                        <div className={styles.elm_col3_icons_elm_title}>Высота конструкции</div>
                        <div className={styles.elm_col3_icons_elm_text} dangerouslySetInnerHTML={{__html: elm?.height}} />
                      </div>
                    </div>
                    <div className={styles.elm_col3_icons_elm}>
                      <Image src={`/${assets_path}/images/maximize-2.svg`} width={20} height={20} alt={`Ширина`} />
                      <div>
                        <div className={styles.elm_col3_icons_elm_title}>Ширина створки</div>
                        <div className={styles.elm_col3_icons_elm_text} dangerouslySetInnerHTML={{__html: elm?.width}} />
                      </div>
                    </div>
                    <div className={styles.elm_col3_icons_sep} />
                    <div className={styles.elm_col3_icons_elm}>
                      <Image src={`/${assets_path}/images/empty-wallet.svg`} width={20} height={20} alt={`Цена`} />
                      <div>
                        <div className={styles.elm_col3_icons_elm_title}>Цена</div>
                        <div className={styles.elm_col3_icons_elm_text} dangerouslySetInnerHTML={{__html: elm?.price}} />
                      </div>
                    </div>
                  </div>
                  <GreenButton
                    text={`Узнать точную стоимость`}
                    width={113}
                    className={styles.elm_col3_button}
                    action={() => this.showFeedback(`Узнать точную стоимость`)}
                  />
                </div>
                <div>
                  {/* Заменяем ссылку на div с обработчиком клика для открытия видео в модальном окне */}
                  <div 
                    className={styles.elm_col3_video}
                    onClick={() => this.openVideoModal(elm?.link)}
                    role="button"
                    tabIndex={0}
                    onKeyUp={(e) => e.key === 'Enter' && this.openVideoModal(elm?.link)}
                    style={{cursor: 'pointer'}}
                  >
                    <Image src={elm?.poster} width={279} height={190} alt={elm?.title} />
                    <WhiteButton className={styles.elm_col3_video_btn} />
                  </div>
                  {elm?.schema && ( // Показываем кнопку только если есть схема
                    <StormcloudButton
                      text={`Схемы открывания`}
                      width={279}
                      className={styles.elm_col3_button}
                      action={() => this.openLightbox2(k)} // Теперь работает
                    />
                  )}
                </div>
              </div>
            </div>
          ))}
        </Container>
        
        {/* Модальное окно для видео */}
        <Modal 
          show={show_video_modal} 
          onHide={this.closeVideoModal}
          size="lg"
          centered
          className={styles.video_modal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Видео</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0">
            {embedUrl ? (
              <div className={styles.video_container}>
                <iframe
                  src={embedUrl}
                  width="100%"
                  height="405"
                  frameBorder="0"
                  style={{ border: 'none' }}
                  allow="clipboard-write; autoplay"
                  webkitAllowFullScreen
                  mozallowfullscreen
                  allowFullScreen
                  title="Видео"
                />
              </div>
            ) : (
              <p>Неверная ссылка на видео</p>
            )}
          </Modal.Body>
        </Modal>

        <FeedbackForm
          title={form_title}
          text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
          btn={`Отправить`}
          data={[]}
          show={show_feedback}
          handleClose={() => this.closeFeedback()}
        />
      </section>
    )
  }
}

HSPortaliBlock.propTypes = {
  data: PropTypes.object,
  assets_path: PropTypes.string
}

HSPortaliBlock.defaultProps = {
  data: {},
  assets_path: ``
}

export default HSPortaliBlock